import type { LanguageCode } from "./language-codes";
import type { ComponentProps } from "react";
import { Badge } from "@acdc2/ui/components/badge";
import { CommandItem } from "@acdc2/ui/components/command";
import { mdiCheck } from "@mdi/js";
import { Icon } from "@mdi/react";

type Props = ComponentProps<typeof CommandItem> & {
  name: string;
  code: LanguageCode;
  selected?: boolean;
  onSelect: () => void;
};

export function LanguageCommandItem({ name, code, selected, ...props }: Props) {
  return (
    <CommandItem value={code} keywords={[name]} {...props}>
      {name}
      {selected && <Icon path={mdiCheck} size="1.25rem" />}
      <Badge className="ml-auto">{code.toUpperCase()}</Badge>
    </CommandItem>
  );
}
